import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-lang-file-dialog',
  templateUrl: './select-lang-file-dialog.component.html',
  styleUrls: ['./select-lang-file-dialog.component.css'],
  standalone: false,
})
export class SelectLangFileDialogComponent implements OnInit {

  //LanguageFilesコレクション
  private langFilesCollection!: AngularFirestoreCollection<any>;
  langFilesObservable!: Observable<any[]>;
  langFilesSubscribe!: Subscription;
  
  displayedColumns: string[] = ['position', 'select', 'file', 'name',];
  dataSource = new MatTableDataSource<any>();

  fileList: any[] = [];

  currentLang: string = 'ja';

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;

  constructor(
    private angularFirestore: AngularFirestore,
    public dialogRef: MatDialogRef<SelectLangFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.langFilesCollection = this.angularFirestore.collection<any>(
      'language_files', ref => ref.orderBy('file_name', 'asc'));
    this.langFilesObservable = this.langFilesCollection.valueChanges({ idField: 'id' });
    this.langFilesSubscribe = this.langFilesObservable.subscribe(langFiles => {
      this.dataSource.data = langFiles;
    });
    this.currentLang = this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.langFilesSubscribe.unsubscribe();
  }

  selectFile(row: any) {
    let langFile: any = {
      file_name: row.file_name,
      download_url: row.download_url,
    }
    this.dialogRef.close(langFile);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
